$(function() {
  $('.LogoSlider > .Container').flickity({
    contain: true,
    imagesLoaded: true,
    pageDots: false,
    wrapAround: true,
    groupCells: 1,
    showCells: 4,
    cellAlign: 'left'
  });
});



// WEBPACK FOOTER //
// ../modules/Logoslider/assets/scripts/main.js